import React from 'react';

import DownloadButton from './downloadButton';

import { CardActions, FlatButton } from 'material-ui';
import NavigationRefresh from 'material-ui/svg-icons/navigation/refresh';

import DeleteButton from './Toggle/DeleteButton';

const BoatActionStyle = {
  zIndex: 2,
  display: 'inline-block',
  float: 'right',
}

export const Actions = ({ ...props, resource, filters, displayedFilters, filterValues, basePath, showFilter, refresh }) => (
  <CardActions style={BoatActionStyle}>
    <DeleteButton />
    {filters && React.cloneElement(filters, { resource, showFilter, displayedFilters, filterValues, context: 'button' }) }
    <DownloadButton {...props} />
    <FlatButton primary label="refresh" onClick={refresh} icon={<NavigationRefresh />} />
  </CardActions>
);



// WEBPACK FOOTER //
// ./src/custom/action_no_save.js